import { c as _c } from "react/compiler-runtime";
import { useContext, useState } from 'react';
import useSWR from 'swr';
import { GlobalContext } from '../../../../contexts/GlobalContext';
import { DashboardContext } from '../../DashboardContext';
import ChangelogCard from './ChangelogCard';
import ChangelogFeed from './ChangelogFeed';
export interface ChangelogEntry {
  id: string;
  title: string;
  short_title?: string;
  description: string;
  product: 'event_gateway' | 'outpost' | 'platform';
  image_src_set?: {
    '1x': string;
    '2x': string;
    '3x': string;
    default: string;
    fallback: string;
  };
  image_dimensions?: {
    width: number;
    height: number;
    aspect_ratio: number;
  };
  card_image_light_src_set?: {
    '1x': string;
    '2x': string;
    '3x': string;
    default: string;
  };
  card_image_dark_src_set?: {
    '1x': string;
    '2x': string;
    '3x': string;
    default: string;
  };
  card_image_dimensions?: {
    width: number;
    height: number;
    aspect_ratio: number;
  };
  content_html: string;
  cta_text?: string;
  cta_link?: string;
  published_at: string;
  type: 'major' | 'minor';
}
interface ChangelogResponse {
  entries: ChangelogEntry[];
}
const useChangelog = t0 => {
  const $ = _c(33);
  const {
    product
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    user
  } = useContext(DashboardContext);
  const [is_dismissed, setIsDismissed] = useState(false);
  const [show_feed, setShowFeed] = useState(false);
  const [local_last_seen, setLocalLastSeen] = useState(user?.last_seen_changelog || null);
  let t1;
  if ($[0] !== product) {
    t1 = async () => {
      const response = await fetch(`${process.env.WEBSITE_URL}/api/changelog/${product}.json`);
      if (!response.ok) {
        throw new Error("Failed to fetch changelog");
      }
      return response.json();
    };
    $[0] = product;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      revalidateOnFocus: false
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    data: changelog_data
  } = useSWR(`/api/changelog/${product}.json`, t1, t2);
  let entries;
  let latest_major_entry;
  let show_changelog;
  let unread_count;
  if ($[3] !== changelog_data?.entries || $[4] !== is_dismissed || $[5] !== local_last_seen || $[6] !== user) {
    entries = changelog_data?.entries || [];
    latest_major_entry = entries.find(_temp);
    const calculateUnreadCount = last_seen => {
      if (!entries || entries.length === 0) {
        return 0;
      }
      if (!last_seen) {
        return entries.length;
      }
      const last_seen_date = new Date(last_seen);
      const unread_entries = entries.filter(entry_0 => {
        const entry_date = new Date(entry_0.published_at);
        return entry_date > last_seen_date;
      });
      return unread_entries.length;
    };
    const t3 = local_last_seen || user?.last_seen_changelog;
    let t4;
    if ($[11] !== calculateUnreadCount || $[12] !== t3) {
      t4 = calculateUnreadCount(t3);
      $[11] = calculateUnreadCount;
      $[12] = t3;
      $[13] = t4;
    } else {
      t4 = $[13];
    }
    unread_count = t4;
    show_changelog = false;
    if (latest_major_entry) {
      show_changelog = true;
      if (user?.last_dismissed_changelog) {
        const dismissed_date = new Date(user.last_dismissed_changelog);
        const update_date = new Date(latest_major_entry.published_at);
        if (dismissed_date >= update_date) {
          show_changelog = false;
        }
      }
      if (is_dismissed) {
        show_changelog = false;
      }
    }
    $[3] = changelog_data?.entries;
    $[4] = is_dismissed;
    $[5] = local_last_seen;
    $[6] = user;
    $[7] = entries;
    $[8] = latest_major_entry;
    $[9] = show_changelog;
    $[10] = unread_count;
  } else {
    entries = $[7];
    latest_major_entry = $[8];
    show_changelog = $[9];
    unread_count = $[10];
  }
  let t3;
  if ($[14] !== HookdeckAPI.session) {
    t3 = async () => {
      setIsDismissed(true);
      await HookdeckAPI.session.updateMe({
        last_dismissed_changelog: new Date().toISOString()
      });
    };
    $[14] = HookdeckAPI.session;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  const handleDismiss = t3;
  let t4;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = async () => {
      setShowFeed(true);
    };
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  const handleOpenFeed = t4;
  let t5;
  if ($[17] !== HookdeckAPI.session) {
    t5 = async () => {
      setShowFeed(false);
      const now = new Date().toISOString();
      setLocalLastSeen(now);
      setIsDismissed(true);
      await HookdeckAPI.session.updateMe({
        last_seen_changelog: now,
        last_dismissed_changelog: now
      });
    };
    $[17] = HookdeckAPI.session;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  const handleCloseFeed = t5;
  let t6;
  if ($[19] !== handleDismiss || $[20] !== latest_major_entry || $[21] !== show_changelog) {
    t6 = latest_major_entry && show_changelog && <ChangelogCard entry={latest_major_entry} onDismiss={handleDismiss} onOpenFeed={handleOpenFeed} />;
    $[19] = handleDismiss;
    $[20] = latest_major_entry;
    $[21] = show_changelog;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== entries || $[24] !== handleCloseFeed || $[25] !== local_last_seen || $[26] !== show_feed || $[27] !== user?.last_seen_changelog) {
    t7 = show_feed && <ChangelogFeed changelog_entries={entries} last_seen_changelog={local_last_seen || user?.last_seen_changelog} onClose={handleCloseFeed} />;
    $[23] = entries;
    $[24] = handleCloseFeed;
    $[25] = local_last_seen;
    $[26] = show_feed;
    $[27] = user?.last_seen_changelog;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  let t8;
  if ($[29] !== t6 || $[30] !== t7 || $[31] !== unread_count) {
    t8 = {
      showFeed: handleOpenFeed,
      unread_count,
      ChangelogCard: t6,
      ChangelogFeed: t7
    };
    $[29] = t6;
    $[30] = t7;
    $[31] = unread_count;
    $[32] = t8;
  } else {
    t8 = $[32];
  }
  return t8;
};
export default useChangelog;
function _temp(entry) {
  return entry.type === "major";
}